// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3yUfd","overflowing":"ReadFullNote_overflowing__2jAtt"};